import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { useMemo } from "react";
import {
  RequirementTableCallback,
  RequirementTableItemData,
  RequirementTableRowConfig
} from "../../types";
import { buildConfigFields } from "../../utils";
import { usePayeeRegistrationConfig } from "./configs/payee/usePayeeRegistrationConfig";
import { usePayerRegistrationConfig } from "./configs/payer/usePayerRegistrationConfig";

export const useRegistrationRequirementTableConfig = (
  callback: RequirementTableCallback,
  requirements: RequirementTableItemData[]
): RequirementTableRowConfig[RequirementType.Registration] => {
  const payerRegistrationConfig = usePayerRegistrationConfig(callback);
  const payeeRegistrationConfig = usePayeeRegistrationConfig(callback);

  const fields = useMemo(
    () =>
      buildConfigFields<any, RequirementType.Registration>({
        payerConfig: payerRegistrationConfig,
        payeeConfig: payeeRegistrationConfig,
        getAdditionalData: (requirement: IRequirementResponse) => {
          return requirement.dataSourceMetadata;
        }
      })(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [payerRegistrationConfig, payeeRegistrationConfig]
  );

  return {
    ...fields,
    getAdditionalData: () => undefined,
    isLoading: false,
    dataUpdatedAt: ""
  };
};
